<template>
<div class="app-container1" >
  <div id="base" class="">

     



      <!-- Unnamed (Rectangle) -->
      <div id="u869" class="ax_default box_1">
        <div id="u869_div" class=""></div>
        <div id="u869_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u870" class="ax_default box_1">
        <div id="u870_div" class=""></div>
        <div id="u870_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u871" class="ax_default box_1">
        <div id="u871_div" class=""></div>
        <div id="u871_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u872" class="ax_default" data-left="579" data-top="112" data-width="500" data-height="24">

        <!-- Unnamed (Rectangle) -->
        <div id="u873" class="ax_default label">
          <div id="u873_div" class=""></div>
          <div id="u873_text" class="text ">
            <p><span>{{this.electricLevel1VO.yearuseusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u874" class="ax_default label">
          <div id="u874_div" class=""></div>
          <div id="u874_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u875" class="ax_default label">
          <div id="u875_div" class=""></div>
          <div id="u875_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u876" class="ax_default label">
          <div id="u876_div" class=""></div>
          <div id="u876_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u877" class="ax_default label">
          <div id="u877_div" class=""></div>
          <div id="u877_text" class="text ">
            <p><span>{{this.electricLevel1VO.yearchangeusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u878" class="ax_default label">
          <div id="u878_div" class=""></div>
          <div id="u878_text" class="text ">
            <p><span>{{this.electricLevel1VO.yearchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u879" class="ax_default image" v-if="electricLevel1VO.yearchangerate>=0">
          <img id="u879_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u879_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
       <div id="u879" class="ax_default image" v-if="electricLevel1VO.yearchangerate<0">
          <img id="u879_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u879_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <!-- Unnamed (Image) -->
        <div id="u880" class="ax_default image" v-if="electricLevel1VO.yearchangeusage>=0">
          <img id="u880_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u880_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
         <div id="u880" class="ax_default image" v-if="electricLevel1VO.yearchangeusage<0">
          <img id="u880_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u880_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u881" class="ax_default" data-left="292" data-top="212" data-width="351" data-height="68">

        <!-- Unnamed (Rectangle) -->
        <div id="u882" class="ax_default label">
          <div id="u882_div" class=""></div>
          <div id="u882_text" class="text ">
            <p><span>自来水</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u883" class="ax_default label">
          <div id="u883_div" class=""></div>
          <div id="u883_text" class="text ">
            <p><span>{{this.electricLevel1VO.tapwateruseusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u884" class="ax_default label">
          <div id="u884_div" class=""></div>
          <div id="u884_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u885" class="ax_default label">
          <div id="u885_div" class=""></div>
          <div id="u885_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u886" class="ax_default label">
          <div id="u886_div" class=""></div>
          <div id="u886_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u887" class="ax_default label">
          <div id="u887_div" class=""></div>
          <div id="u887_text" class="text ">
            <p><span>{{this.electricLevel1VO.tapwaterchangeuseusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u888" class="ax_default label">
          <div id="u888_div" class=""></div>
          <div id="u888_text" class="text ">
            <p><span>{{this.electricLevel1VO.tapwaterchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) 
        <div id="u889" class="ax_default image">
          <img id="u889_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u889_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

     
        <div id="u890" class="ax_default image">
          <img id="u890_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u890_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
       -->
 <div v-if="this.electricLevel1VO.tapwaterchangeuseusage>=0" id="u889" class="ax_default image">

          <img id="u889_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u889_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      <div v-if="this.electricLevel1VO.tapwaterchangeuseusage<0" id="u889" class="ax_default image">

          <img id="u889_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u889_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
 <div v-if="this.electricLevel1VO.tapwaterchangeuseusage>=0" id="u890" class="ax_default image">

          <img id="u890_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u890_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      <div v-if="this.electricLevel1VO.tapwaterchangeuseusage<0" id="u890" class="ax_default image">

          <img id="u890_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u890_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

      </div>

      <!-- Unnamed (Line) -->
      <div id="u891" class="ax_default line">
        <img id="u891_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
        <div id="u891_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u892" class="ax_default label">
        <div id="u892_div" class=""></div>
        <div id="u892_text" class="text ">
          <p><span>分项年度用量</span></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u893" class="ax_default" data-left="292" data-top="311" data-width="347" data-height="70">

        <!-- Unnamed (Rectangle) -->
        <div id="u894" class="ax_default label">
          <div id="u894_div" class=""></div>
          <div id="u894_text" class="text ">
            <p><span>中水</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u895" class="ax_default label">
          <div id="u895_div" class=""></div>
          <div id="u895_text" class="text ">
            <p><span>{{this.electricLevel1VO.reclaimedwateruseusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u896" class="ax_default label">
          <div id="u896_div" class=""></div>
          <div id="u896_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u897" class="ax_default label">
          <div id="u897_div" class=""></div>
          <div id="u897_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u898" class="ax_default label">
          <div id="u898_div" class=""></div>
          <div id="u898_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u899" class="ax_default label">
          <div id="u899_div" class=""></div>
          <div id="u899_text" class="text ">
            <p><span>{{this.electricLevel1VO.reclaimedwaterchangeuseusage}}m³</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u900" class="ax_default label">
          <div id="u900_div" class=""></div>
          <div id="u900_text" class="text ">
            <p><span>{{this.electricLevel1VO.reclaimedwaterchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image)
        <div id="u901" class="ax_default image">
          <img id="u901_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u901_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <div id="u902" class="ax_default image">
          <img id="u902_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u902_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        -->
          <div v-if="this.electricLevel1VO.reclaimedwaterchangeuseusage>=0" id="u901" class="ax_default image">

          <img id="u901_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u901_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      <div v-if="this.electricLevel1VO.reclaimedwaterchangeuseusage<0" id="u901" class="ax_default image">

          <img id="u901_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u901_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
         <div v-if="this.electricLevel1VO.reclaimedwaterchangeuseusage>=0" id="u902" class="ax_default image">

          <img id="u902_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u902_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      <div v-if="this.electricLevel1VO.reclaimedwaterchangeuseusage<0" id="u902" class="ax_default image">

          <img id="u902_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u902_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

  

      <!-- Unnamed (Group) -->
      <div id="u904" class="ax_default" data-left="263" data-top="455" data-width="1149" data-height="276">

        <!-- Unnamed (Rectangle) -->
        <div id="u905" class="ax_default label">
          <div id="u905_div" class=""></div>
          <div id="u905_text" class="text ">
            <p><span>用水详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u906" class="ax_default box_1">
          <div id="u906_div" class=""></div>
          <div id="u906_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u907" class="ax_default label">
          <div id="u907_div" class=""></div>
          <div id="u907_text" class="text ">
            <p><span>项目</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u908" class="ax_default droplist">
  <el-select  @change="changeProject" clearable v-model="queryParams.projectId"  placeholder="选择项目">
                                            <el-option
                                                    v-for="item in projectList"
                                                    :label="item.projectName"
                                                    :value="item.projectId"
                                                    :key="item.projectId">
                                            </el-option>
                    </el-select>
          <!-- <div id="u908_div" class=""></div>
          <select id="u908_input" class="u908_input" v-model="queryParams.area">
            <option class="u908_input_option" selected value="">请选择</option>
            <option class="u908_input_option" value="一期">一期</option>
            <option class="u908_input_option" value="二期">二期</option>
          </select>-->
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u909" class="ax_default label">
         <!-- <div id="u909_div" class=""></div>
          <div id="u909_text" class="text ">
            <p><span>周期</span></p>
          </div>-->
        </div>

        <!-- Unnamed (Image) -->
        <div id="u910" class="ax_default image">
        
 <!--
          <img id="u910_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u392.png"/>
          -->
          <div id="u910_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u911" class="ax_default primary_button" @click="handleQuery">
          <div id="u911_div" class=""></div>
          <div id="u911_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u912" class="ax_default box_1">
          <div id="u912_div" class=""></div>
          <div id="u912_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u913" class="ax_default heading_1">
          <div id="u913_div" class=""></div>
          <div id="u913_text" class="text ">
            <p><span></span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u914" class="ax_default heading_1">
          <div id="u914_div" class=""></div>
          <div id="u914_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u915" class="ax_default box_1">
          <div id="u915_div" class=""></div>
          <div id="u915_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u916" class="ax_default primary_button">
          <div id="u916_div" class=""></div>
          <div id="u916_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u917" class="ax_default label">
          <div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
           <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="分项" align="center" prop="childtype" />
                <el-table-column label="区域" align="center" prop="area" />
 <!--
              <el-table-column label="楼栋" align="center" prop="building" />
               <el-table-column label="单元" align="center" prop="unit" />
 -->
                <el-table-column label="用量" align="center" prop="useusage" />
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u918" class="ax_default label">
          <div id="u918_div" class=""></div>
          <div id="u918_text" class="text ">
            <p><span>分项</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u919" class="ax_default droplist">
          <div id="u919_div" class=""></div>
          <select id="u919_input" class="u919_input" v-model="queryParams.childtype">
            <option class="u919_input_option" selected value="">请选择</option>
            <option class="u919_input_option" value="2">自来水</option>
            <option class="u919_input_option" value="1">中水</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u920" class="ax_default label">
          <div id="u920_div" class=""></div>
          <div id="u920_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u921" class="ax_default droplist">
            <tree-select
                                    v-model="queryParams.positionId"
                                    @select="selectPosition"
                                    :disable-branch-nodes="false"
                                    :multiple="false"
                                    :show-count="true"
                                    :flat="true"
                               
                                    :autoFocus="true"
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="positionList" />
           <!--
          <div id="u921_div" class=""></div>
          <select id="u921_input" class="u921_input" v-model="queryParams.building">
            <option class="u921_input_option" selected value="">请选择</option>
            <option class="u921_input_option" value="1栋">1栋</option>
            <option class="u921_input_option" value="2栋">2栋</option>
            <option class="u921_input_option" value="3栋">3栋</option>
            <option class="u921_input_option" value="4栋">4栋</option>
          </select>-->
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u922" class="ax_default label">
          <div id="u922_div" class=""></div>
          <div id="u922_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u923" class="ax_default droplist">
  <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                    @change="setDateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
        <!--  <div id="u923_div" class=""></div>
          <select id="u923_input" class="u923_input" v-model="queryParams.unit">
            <option class="u923_input_option" selected value="">请选择</option>
            <option class="u923_input_option" value="1单元">1单元</option>
            <option class="u923_input_option" value="2单元">2单元</option>
            <option class="u923_input_option" value="3单元">3单元</option>
            <option class="u923_input_option" value="4单元">4单元</option>
          </select>-->
        </div>

       
     
      </div>

      <!-- Unnamed (Line) -->
      <div id="u928" class="ax_default _水平线">
        <img id="u928_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u782.svg"/>
        <div id="u928_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u929" class="ax_default line">
        <img id="u929_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u929_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u930" class="ax_default label">
        <div id="u930_div" class=""></div>
        <div id="u930_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.tapwaterusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u931" class="ax_default line">
        <img id="u931_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u931_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u932" class="ax_default label">
        <div id="u932_div" class=""></div>
        <div id="u932_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.reclaimedwaterusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u933" class="ax_default box_1">
        <div id="u933_div" class=""></div>
        <!--
        <div id="u933_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
        -->
                 <div id="u9331" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in electricLevel1VO.arealist">
  <tr style="height:18px"> 
      <td  width="250px" ></td> 
      <td align="left" width="100"><span style="font-size:14px;">总用量</span></td>  
      <td align="left" width="80"><span style="font-size:14px;">{{item.useusage}}Kwh</span></td>        
  </tr>
   <tr style="height:18px">   
       <td  width="250px" >
      <span style="font-size:14px;"> {{item.area}}</span>
      </td> 
       <td align="left" width="100"><span style="font-size:14px;">同比变化量</span></td>  
       <td align="left" width="80" v-if="item.changeusage>=0"><span style="font-size:14px;">{{item.changeusage}}Kwh</span>
          <img id="u8791_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>  
        </td>  
         <td align="left" width="80" v-if="item.changeusage<0"><span style="font-size:14px;">{{item.changeusage}}Kwh</span>
          <img id="u8791_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>  
        </td>  
  </tr>
   <tr style="height:18px">    
      <td  width="250px" ></td> 
       <td align="left" width="100"><span style="font-size:14px;">同比变化率</span></td>  
       <td align="left" width="80" v-if="item.changerate>=0"><span style="font-size:14px;">{{item.changerate}}%</span>
        <img id="u8791_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>        
       </td>
       <td align="left" width="80" v-if="item.changerate<0"><span style="font-size:14px;">{{item.changerate}}%</span>
        <img id="u8791_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>        
       </td>
  </tr>
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
      </div>

      <!-- Unnamed (Group) -->
  

      <!-- Unnamed (Rectangle) -->
      <div id="u944" class="ax_default label">
        <div id="u944_div" class=""></div>
        <div id="u944_text" class="text ">
          <p><span>区域年度用量</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u945" class="ax_default line">
        <img id="u945_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
        <div id="u945_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
  
   
   </div>
  
</div>



</template>
<script>
import "echarts/theme/macarons";
import {
  getLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getAirconditionLevel2,//空调
  listAircondition,//空调
  getPowerchildLevel2,//动力
  listPowerchild,//动力
  getLightchildLevel2,//照明
  listLightchild,//照明
  getSpecialchildLevel2,//特殊用电
  listSpecialchild,//特殊用电

} from "@/api/business/energy/consumption";
import Pagination from '@/components/Pagination';
 import{
        getProjectList
    }from '@/api/business/base/tenant/project';
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device';
     import {listToTree} from '@/utils/tree';
    import TreeSelect from '@riophae/vue-treeselect';   
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  name: "energyOverview",
    components: {Pagination,TreeSelect},
  data() {
    return {
      list: null,
       useusage: "",
      changeusage: "",
      changerate: "",
      hotYear: "",
      othersYear: "",
      consumptionList: [],
            projectList:[],
               positionList:[],
       list: null,
          // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   childtype: '',
                   area: '',
                   building: '',
                   unit: '',
                   energytype: '',
               
                   areaid: null,
                 positionId : null,
                   projectId: null,
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      childEnergyType: [
        { itemCode: 1, itemName: "中水" },
        { itemCode: 2, itemName: "自来水" },
      ],
      areaTypeList: [
         { itemCode: 1, itemName: "一区" },
        { itemCode: 2, itemName: "二区" },
        { itemCode: 3, itemName: "三区" },
        { itemCode: 4, itemName: "四区" },
      ],
      buildingTypeList: [
        { itemCode: 1, itemName: "1号楼" },
        { itemCode: 2, itemName: "2号楼" },
        { itemCode: 3, itemName: "3号楼" },
        { itemCode: 4, itemName: "4号楼" },
      ],
      unitTypeList: [
        { itemCode: 1, itemName: "1单元" },
        { itemCode: 2, itemName: "2单元" },
        { itemCode: 3, itemName: "3单元" },
        { itemCode: 4, itemName: "4单元" },
      ],
      tableData: [
        {
          item1: "2020-05",
          item2: "办公区",
          item3: "一栋",
           item4: "一单元",
            item5: "中水",
             item6: "2351.2",
        },
        {
          item1: "2020-06",
          item2: "办公区",
          item3: "一栋",
           item4: "一单元",
            item5: "自来水",
             item6: "2351.2",
      
        },
      ],
      dayData: [
        // {
        //   name: "自来水（m3）",
        //   count: 1678,
        //   proportion: 67,
        // },
        // {
        //   name: "中水（m3）",
        //   count: 1000,
        //   proportion: 33,
        // },
      ],
      monthData: [
        {
          name: "空调用电（Kwh）",
          count: 5646,
          proportion: 20,
        },
        {
          name: "照明用电（Kwh）",
          count: 5646,
          proportion: 30,
        },
        {
          name: "动力用电（Kwh）",
          count: 5646,
          proportion: 30,
        },
        {
          name: "特殊用电（Kwh）",
          count: 5646,
          proportion: 20,
        },
      ],
      yearData: [
        {
          name: "年空调用电（Kwh）",
          count: 56465,
          proportion: 20,
        },
        {
          name: "年照明用电（Kwh）",
          count: 10065,
          proportion: 20,
        },
        {
          name: "年动力用电（Kwh）",
          count: 46465,
          proportion: 20,
        },
        {
          name: "年特殊用电（Kwh）",
          count: 16465,
          proportion: 40,
        },
      ],
      paramsData: [],
      initData: null,
      electricityProportionOptions: null,
      monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      monthlyProportionOptionsArea: null,
        monthlyProportionOptionsRateArea: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
            //-
        //接收总统计数据的对象
            consumptionLevel1VO: {
              //----------汇总数据-------------
    //今年总量
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5


    //---今年用量变化
    powerChangeYear: "",
    waterChangeYear: "",
    gasChangeYear: "",
    hotChangeYear: "",
    othersChangeYear: "",

    //---今年用量变化率
    powerChangeRateYear: "",
    waterChangeRateYear: "",
    gasChangeRateYear: "",
    hotChangeRateYear: "",
    othersChangeRateYear: ""
        },
        electricLevel1VO: {
            arealist: [],
            yearuseusage: "",
            yearchangeusage: "",
            yearchangerate: "",

            timeno: "",
            airconditionuseusage: "",
            airconditionchangeuseusage: "",
            airconditionchangerate: "",
            airconditionusagepercent: "",

            lightuseusage: "",
            lightchangeuseusage: "",
            lightchangerate: "",
            lightusagepercent: "",

            poweruseusage: "",
            powerchangeuseusage: "",
            powerchangerate: "",
            powerusagepercent: "",

            specialuseusage: "",
            specialchangeuseusage: "",
            specialchangerate: "",
            specialusagepercent: "",
              //中水
            reclaimedwateruseusage: "",
            reclaimedwaterchangeuseusage: "",
            reclaimedwaterchangerate: "",
            reclaimedwaterusagepercent: "",
              //自来水
            tapwateruseusage: "",
            tapwaterchangeuseusage: "",
            tapwaterchangerate: "",
            tapwaterusagepercent: "",
        }
    };
  },
  created() {
     getWaterLevel2(this.queryParams).then((response) => {
           //alert("11111");
          this.electricLevel1VO = response.data;
   
  
        });
       
    this.getProjectList();

     getLevel1(this.queryParams).then((response) => {
           //alert("11111");
          this.consumptionLevel1VO = response.data;
   
           this.electricLevel1VO.yearuseusage=this.consumptionLevel1VO.waterYear;
           this.electricLevel1VO.yearchangeusage=this.consumptionLevel1VO.waterChangeYear;
             this.electricLevel1VO.yearchangerate=this.consumptionLevel1VO.waterChangeRateYear;
          
        });
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
          setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },

//--------------------
   /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;
       this.queryParams.areaid=this.queryParams.positionId;
      listWater(this.queryParams).then((response) => {
           //alert("11111");
           for(var i=0;i<response.rows.length;i++){
             //alert(response.rows[i].childtype);
               if(response.rows[i].childtype==1){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='中水';
              }
                 if(response.rows[i].childtype==2){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='自来水';
              }
                 
           }
          this.consumptionList = response.rows;
          this.total = response.total;
        this.loading = false;
        });
    
     },
//--------------------
 //----------------位置选择----------------------------
             selectPosition(node){
                this.queryParams.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                })
                //alert(this.projectList.length);
            },
           changeProject() {
                if(this.queryParams.projectId == ''){
                    this.queryParams.projectId = null;
                    this.queryParams.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.queryParams.projectId}).then(response =>{
                     
                        //alert(this.listQuery.projectId);
                        this.queryParams.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                this.positionList = data;
            },
          
           

    //----------------------------------------------
}
}
</script>
<style scoped src="../../../../../../assets/common/consumption/css/water/styles.css"></style>
<style scoped src="../../../../../../assets/common/consumption/css/styles.css"></style>
<style scoped src="../../../../../../assets/common/rp_page.css"></style>
<style scoped>
    .app-container1 {
  margin: 0px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 300px);
  
}
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
.innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>
